import React from "react"

// Figma: 와우넷 숏폼 AI 요약 / "작게" 버튼의 - 아이콘 (node 3:1332)
// 색상은 stroke="currentColor"로 버튼 텍스트 색을 상속한다.
export default function MinusIcon() {
  return (
    <svg
      width="7"
      height="7"
      viewBox="0 0 7 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M0 3.5H7" stroke="currentColor" strokeWidth="1" />
    </svg>
  )
}
